module.exports = __webpack_public_path__ + "img/switch-projects.7cb908de.svg";